import React from 'react'

import { HandCoinIcon } from '~/assets/icons'
import Trend from '~/assets/icons/trend'
import { getProviderPriceRiseContent } from '~/components/filter-banner/price-rise-banner/providers-price-rise-content'

import styles from './styles.module.css'

interface Props {
  providerId: string
}

export const PriceRiseDetails: React.FC<Props> = ({ providerId }) => {
  const priceRiseContent = getProviderPriceRiseContent(providerId)

  const IconBadge: React.FC<{ className: string; icon: JSX.Element }> = ({ className, icon }) => (
    <span className={className}>{icon}</span>
  )

  const Heading: React.FC = () => {
    if (priceRiseContent?.until)
      return (
        <span className={styles.heading}>
          <IconBadge className={styles.iconBadgeGreen} icon={<HandCoinIcon className={styles.icon} />} />

          <span className={styles.text}>No price rise in 2024</span>
        </span>
      )

    if (priceRiseContent?.average) {
      return (
        <span className={styles.heading}>
          <IconBadge className={styles.iconBadgeBlue} icon={<Trend className={styles.icon} />} />

          <span className={styles.text}>Monthly cost may rise during contract</span>
        </span>
      )
    }

    if (priceRiseContent?.priceIncrease)
      return (
        <span className={styles.heading}>
          <IconBadge className={styles.iconBadgeBlue} icon={<Trend className={styles.icon} />} />

          <span className={styles.text}>Monthly cost will rise during contract</span>
        </span>
      )

    return (
      <span className={styles.heading}>
        <IconBadge className={styles.iconBadgeGreen} icon={<HandCoinIcon className={styles.icon} />} />

        <span className={styles.text}>No price rise during contract</span>
      </span>
    )
  }

  return (
    <>
      <span className={styles.title}>Price rises</span>

      <Heading />

      <div className={styles.text}>{priceRiseContent?.priceDetails}</div>

      <div className={styles.spacer} />
    </>
  )
}
